import { Outlet } from "react-router-dom";

const CitizenLayout = () => {
  return (
    <div>
      <Outlet />
    </div>
  );
};

export default CitizenLayout;
